import { apiConfig } from './apiConfig'
export const apiService = {
  postFormData (url = '', requestInfo) {
    // Default options are marked with *
    return window.fetch(url, requestInfo).then((response) => {
      return response.json()
    }).catch(err => {
      console.dir(err)
      console.error(`Error sending data to API: ${err}`)
    })
  },
  // <summary>
  // boolean promise method that returns true if the e-mail is sent successfully via the API.
  // pass in the state object to get parsed into an html template that will be sent as thet body via an api call
  // </summary>
  async attemptPostData (state) {
    const parse = function (date) {
      if (!date) return ''
      var mm = date.getMonth() + 1 // getMonth() is zero-based
      var dd = date.getDate()

      return [
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd,
        date.getFullYear()
      ].join('/')
    }
    const appState = { ...state.app }
    // have to stringify the request data, because the emailTemplate is a full HTML body,
    // otherwise express' json parser has issues parsing the value
    const body = { ...appState, dateOfBirth: parse(appState.dateOfBirth) }
    const requestBody = JSON.stringify(body)
    const request = {
      method: this.HTTP_VERBS.POST,
      body: requestBody,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const uri = `${apiConfig.baseUrl}${apiConfig.endpoint}`
    return new Promise((resolve, reject) => {
      this.postFormData(uri, request).then((response) => {
        const success = (response && response.statusCode === 200)
        const rejection = `API Call to SFB failed, response: ${JSON.stringify(response)}`
        return success ? resolve(true) : reject(rejection)
      }).catch(err => {
        console.error(`HTTP Call to SFB failed, error: ${err}`)
        return reject(err)
      })
    })
  },
  HTTP_VERBS: {
    POST: 'POST',
    GET: 'GET',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
  }
}
export default apiService
